__turbopack_context__.v({
  "arrow": "bZOX8G_arrow",
  "body": "bZOX8G_body",
  "cta": "bZOX8G_cta",
  "icon": "bZOX8G_icon",
  "item": "bZOX8G_item",
  "list": "bZOX8G_list",
  "row": "bZOX8G_row",
  "signOut": "bZOX8G_signOut",
});
